import { Avatar, type AvatarProps } from '@mui/material';
import { useEffect, useState } from 'react';

import { api } from '../lib/api';

type AuthAvatarProps = Omit<AvatarProps, 'src'> & {
  src: string | null | undefined;
  alt: string;
};

export function AuthAvatar({ src, alt, children, ...props }: AuthAvatarProps) {
  const [resolvedSrc, setResolvedSrc] = useState<string | null>(null);

  useEffect(() => {
    if (!src) {
      setResolvedSrc(null);
      return undefined;
    }

    if (!src.startsWith('/api/v1/')) {
      setResolvedSrc(src);
      return undefined;
    }

    let objectUrl: string | null = null;
    let cancelled = false;

    void api
      .get(src.replace('/api/v1', ''), { responseType: 'blob' })
      .then((response) => {
        if (cancelled) {
          return;
        }

        objectUrl = URL.createObjectURL(response.data);
        setResolvedSrc(objectUrl);
      })
      .catch(() => {
        if (!cancelled) {
          setResolvedSrc(null);
        }
      });

    return () => {
      cancelled = true;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [src]);

  return (
    <Avatar src={resolvedSrc ?? undefined} alt={alt} {...props}>
      {children}
    </Avatar>
  );
}
